import React from "react";

type WistiaPlayerProps = {
  mediaId: string;
  title?: string;
  className?: string;
};

const WistiaPlayer = ({ mediaId, title, className = "" }: WistiaPlayerProps) => {
  if (!mediaId) {
    return null;
  }

  const embedUrl = `https://fast.wistia.net/embed/iframe/${mediaId}?seo=false&videoFoam=true`;

  return (
    <div className={`w-full ${className}`}>
      <div className="relative w-full overflow-hidden rounded-md bg-black" style={{ paddingTop: "56.25%" }}>
        <iframe
          src={embedUrl}
          title={title || "Wistia video"}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 h-full w-full border-0"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default WistiaPlayer;
